import React from 'react';

import PolicyPage from '../common/PolicyPage';

const Faq: React.FC = () => {
  return <PolicyPage name="faq" title="Frequently Asked Questions" />;
};

export default Faq;
